import React from 'react';
import PropTypes from 'prop-types';
import s from './Mocktale.scss';

const Mocktale = props => (
  <div className={s.mocktale}>
    <span dangerouslySetInnerHTML={{ __html: props.disclaimer }} />
  </div>
);
Mocktale.propTypes = {
  disclaimer: PropTypes.string,
};
Mocktale.defaultProps = {
  disclaimer: '',
};
export default Mocktale;
